module.exports = __webpack_public_path__ + "img/AV_Logo.d0883abc.svg";